import { Apollo } from 'apollo-angular';
import { DocumentNode } from 'graphql';


export interface PaginateParams {
  apollo: Apollo;
  query: DocumentNode;
  perPage: number;
  itemsPropertyName: string;
}

export async function paginate<T>({ apollo, query, perPage, itemsPropertyName }: PaginateParams): Promise<T[]> {
  const items: T[] = [];

  let totalCount = null;
  let offset = 0;
  const limit = perPage;

  while (totalCount === null || totalCount > items.length) {
    const variables = {
      limit,
      offset,
    };

    const response = await apollo
    .query({ query, variables })
    .toPromise();

    const page = response.data[itemsPropertyName];

    items.push(...page.items);

    offset += limit;
    totalCount = page.totalCount;
  }

  return items;
}

